/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Frame_Policy_BlockedInputs */

const en_cookie_frame_policy_blocked = /** @type {(inputs: Cookie_Frame_Policy_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This content is unavailable under your region's consent policy.`)
};

const lv_cookie_frame_policy_blocked = /** @type {(inputs: Cookie_Frame_Policy_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šis saturs nav pieejams saskaņā ar Jūsu reģiona piekrišanas politiku.`)
};

/**
* | output |
* | --- |
* | "This content is unavailable under your region's consent policy." |
*
* @param {Cookie_Frame_Policy_BlockedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_frame_policy_blocked = /** @type {((inputs?: Cookie_Frame_Policy_BlockedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Frame_Policy_BlockedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_frame_policy_blocked(inputs)
	return en_cookie_frame_policy_blocked(inputs)
});